var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariant5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    fillOpacity: 0.12,
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M13 16h20.064v1H13v-1Zm0 6.896h8.799v1H13v-1Zm.5 6.897H13v1h10.532v-1H13.5Zm15.597-7.62a2.957 2.957 0 0 0-2.966 2.947 2.957 2.957 0 0 0 2.966 2.948c.82 0 1.56-.33 2.097-.863l.024-.023a2.93 2.93 0 0 0 .845-2.062 2.957 2.957 0 0 0-2.966-2.948Zm3.136 5.364c.52-.667.83-1.506.83-2.417 0-2.183-1.778-3.948-3.966-3.948s-3.966 1.765-3.966 3.948 1.778 3.948 3.966 3.948c.914 0 1.756-.308 2.428-.825l2.417 2.405.355.352.705-.709-.355-.352-2.414-2.402Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 13,
    x2: 35.002,
    y1: 23.5,
    y2: 23.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariant5);
export default __webpack_public_path__ + "static/media/variant5.eeb9b8e215af824a0b7b0207d13c6f69.svg";
export { ForwardRef as ReactComponent };